import { Typography, Box, Stack, IconButton } from "@mui/material";
import React from "react";
import IncrementDecrement from "../IncrementDecrement";
import { Delete } from "@mui/icons-material";

function ResourceListRow({
  data,
  onIncrement,
  onDecrement,
  onDelete,
  canEdit,
  ...props
}) {
  let { name, amount } = data;
  return (
    <Box {...props}>
      <Stack direction={"row"} spacing={3}>
        <Typography width="15rem" alignSelf={"center"}>
          {name}
        </Typography>

        <IncrementDecrement
          canEdit={canEdit}
          amount={amount}
          onIncrement={() => onIncrement(name)}
          onDecrement={() => onDecrement(name)}
        />
        {/* delete icon button */}
        <IconButton
          disabled={!canEdit}
          variant="contained"
          onClick={() => {
            onDelete(name);
          }}
        >
          <Delete />
        </IconButton>
      </Stack>
    </Box>
  );
}

export default ResourceListRow;
